import { SvgIcon } from '@material-ui/core'

export default function ExpandIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <g transform="translate(-2, -2)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.6639 6.34314C13.6639 6.75735 13.9997 7.09314 14.4139 7.09314L16.9065 7.09314V9.58578C16.9065 9.99999 17.2423 10.3358 17.6565 10.3358C18.0707 10.3358 18.4065 9.99999 18.4065 9.58578V6.34314C18.4065 5.92893 18.0707 5.59314 17.6565 5.59314L14.4139 5.59314C13.9997 5.59314 13.6639 5.92893 13.6639 6.34314Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.6565 13.6642C17.2423 13.6642 16.9065 14 16.9065 14.4142L16.9065 16.9069L14.4139 16.9069C13.9996 16.9069 13.6639 17.2426 13.6639 17.6569C13.6639 18.0711 13.9996 18.4069 14.4139 18.4069L17.6565 18.4069C18.0707 18.4069 18.4065 18.0711 18.4065 17.6569L18.4065 14.4142C18.4065 14 18.0707 13.6642 17.6565 13.6642Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.3428 13.6642C6.75701 13.6642 7.0928 14 7.0928 14.4142L7.0928 16.9069L9.58544 16.9069C9.99965 16.9069 10.3354 17.2426 10.3354 17.6569C10.3354 18.0711 9.99965 18.4069 9.58544 18.4069L6.3428 18.4069C5.92859 18.4069 5.5928 18.0711 5.5928 17.6569L5.5928 14.4142C5.5928 14 5.92859 13.6642 6.3428 13.6642Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3354 6.34314C10.3354 6.75735 9.99963 7.09314 9.58541 7.09314L7.09277 7.09314L7.09277 9.58578C7.09277 9.99999 6.75699 10.3358 6.34277 10.3358C5.92856 10.3358 5.59277 9.99999 5.59277 9.58578L5.59277 6.34314C5.59277 5.92893 5.92856 5.59314 6.34277 5.59314L9.58541 5.59314C9.99963 5.59314 10.3354 5.92893 10.3354 6.34314Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    )
}
